import { AsProp, ButtonTertiary } from '@spotify-internal/encore-web';
import { ComponentProps } from 'react';

export type PopoverLink = Omit<ComponentProps<typeof ButtonTertiary>, 'children'> & {
  linkText: string;
  level: number;
  iconLeading?: AsProp;
};

export const MOBILE_NAVIGATION_BREAKPOINT = 992;

export type MastheadContainer = 'header' | 'sidemenu';
